import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CompanyPeriodsEntity } from '../../domain/entities/CompanyPeriodsEntity'
import moment from 'moment'
export class CompanyPeriodsModel extends CompanyPeriodsEntity {
  constructor(dataDto: CompanyPeriodsEntity) {
    super()
    mapEntityProperties<CompanyPeriodsModel>(this, dataDto,{
        map: {
          periods: dataDto.periods?.map((period) => ({
            id: period.id,
            time: period.time
              ? moment.utc(period.time, 'HH:mm:ss').local().format('HH:mm')
              : undefined,
            timeDayOfWeek: period.timeDayOfWeek,
            dayOfWeek: period.dayOfWeek
          }))
        }
      }
    )
  }
}

 